import React from "react"
import ReactDOM from "react-dom"
import TravelGuide from "../travel-guide/travel-guide"

export default class TravelGuideModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.config = elem.dataset.config && JSON.parse(elem.dataset.config)
    self.init()
    return self
  }
  init() {
    const self = this
    if (self.elem.config) {
      const language = document.querySelector("[data-language]")?.dataset.language
      ReactDOM.render(<TravelGuide config={self.elem.config} language={language} />, self.elem)
    }
  }
}
